module.exports = __webpack_public_path__ + "img/wheat_ns1415.39120c93.jpg";